module.exports = __webpack_public_path__ + "Illustration-3.svg?6b2216a6e18d8cdb0ee10575797f31f0";